import { html, LitElement } from "lit";
import {customElement, property} from 'lit/decorators.js';
import style from './main-panel.scss';

/**
 * Main app panel, consisting of left menu and page body.
 *
 * @slot left-menu - Slot for left menu
 * @slot page-body - Slot for main content
 */
@customElement('main-panel')
export class MainPanel extends LitElement {
    static override styles = style;

    /** Should left menu be hidden? */
    @property({attribute: 'left-menu-hidden', type: Boolean, reflect: true})
    leftMenuHidden = false;

    /** Should app width be responsive? Set by usos-layout. */
    @property({reflect: true, type: Boolean}) responsive = false;

    override render() {
        return html`
            <div>
                <slot name="left-menu"></slot>
                <div id="page-body">
                    <slot name="page-body"></slot>
                </div>
            </div>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
      "main-panel": MainPanel,
    }
}
